import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'atsReverseArray',
    standalone: false
})
export class AtsReverseArrayPipe implements PipeTransform {
	constructor() {}

	transform(value: any[]): any[] {
		return value.slice().reverse();
	}
}
